export const orderedAssets = ["ALGO", "USDC", "goBTC", "goETH", "STBL", "vALGO"]
export const extraAssets = []
export const orderedAssetsAndPlaceholders = [
  "ALGO",
  "USDC",
  "goBTC",
  "goETH",
  "STBL",
  "vALGO",
  "SEVN",
  "EGHT",
  "NINE",
  "TENN",
  "ELVN",
  "TWLV",
  "TRTN",
  "FRTN",
  "FVTN",
  "SXTN"
]

export const protocolManagerAppId = 76682821
export const managerAddress = "BD2LNCUZLHYYVDEPG2JAGAN6VC3ULAF6ZL2762OYWBXV4JYAO6FL66TZ2U"
export const assetDictionary = {
  ALGO: {
    marketCounter: 1,
    managerAppId: 76682821,
    decimals: 6,
    marketAppId: 76682298,
    marketAddress: "CNT2BKUX65RRAAWZFW4TVVCDNR24YF3NZ7P7UQYM4PJGF2BRWBGHH77CQY",
    bankAssetId: 76682846,
    bankAssetDecimals: 6,
    underlyingAssetId: 1,
    oracleAppId: 48649676,
    oracleFieldName: "latest_twap_price"
  },
  USDC: {
    marketCounter: 2,
    managerAppId: 76682821,
    decimals: 6,
    marketAppId: 76682307,
    marketAddress: "WV2B2UYMRHEK7XSY3HVLCWKJTSV7ZI5DKQRNWWY4SCN526JDNHV2ASM4CY",
    bankAssetId: 76682898,
    bankAssetDecimals: 6,
    underlyingAssetId: 76682267,
    oracleAppId: 48649820,
    oracleFieldName: "price"
  },
  goBTC: {
    marketCounter: 3,
    managerAppId: 76682821,
    decimals: 8,
    bankAssetDecimals: 8,
    marketAppId: 76682318,
    marketAddress: "QA4LHYDI345WAJU2UPJHPRPWIBUZCUWYYVQ4DA2WKHEPCGFBK35RWBOKHI",
    bankAssetId: 76682957,
    underlyingAssetId: 76682275,
    oracleAppId: 48649713,
    oracleFieldName: "latest_twap_price"
  },
  goETH: {
    marketCounter: 4,
    managerAppId: 76682821,
    decimals: 8,
    marketAppId: 76682330,
    marketAddress: "LBUYTRLVUETVRDCKRG55NFEYQ5TNO3XTMD33YLMIVGOUDX35FUIE6NHPXI",
    bankAssetId: 76683004,
    bankAssetDecimals: 8,
    underlyingAssetId: 76682284,
    oracleAppId: 48649735,
    oracleFieldName: "latest_twap_price"
  },
  STBL: {
    marketCounter: 5,
    managerAppId: 76682821,
    decimals: 6,
    marketAppId: 76682345,
    marketAddress: "OLFMTK7RLRID5J3D6H6ACYSLRTFIJMCKAZSZGQJFVFAYEQTBJUU647NGK4",
    bankAssetId: 76683049,
    bankAssetDecimals: 6,
    underlyingAssetId: 76682292,
    oracleAppId: 48649820,
    oracleFieldName: "price"
  },
  vALGO: {
    marketCounter: 6,
    managerAppId: 76682821,
    decimals: 6,
    marketAppId: 76682360,
    marketAddress: "USJBRCFPMIZ76TWJNOJE3UE627PRNTTWWP5TEOKJH4S27Q66MGZB6IF52Q",
    bankAssetId: 76891649,
    bankAssetDecimals: 6,
    underlyingAssetId: 1,
    oracleAppId: 48649676,
    oracleFieldName: "latest_twap_price"
  },
  SEVN: {
    marketCounter: 7,
    marketAppId: 76682374,
    marketAddress: "DC36K5J7OKJUH3VKV5DPDQWBGLFTGBPMAG67BEHSGIN47UC2HAY5YVW3IQ"
  },
  EGHT: {
    marketCounter: 8,
    marketAppId: 76682393,
    marketAddress: "V5Q6E3M6Y4ZCB6LUIDMVMWBE4U7HHZFDET3LFC6LB25W5TPQOZRQH4WGR4"
  },
  NINE: {
    marketCounter: 9,
    marketAppId: 76682405,
    marketAddress: "XH5UDMQMNCX53TLPDGPFVSIFOWWLUKJYDSEDFOGULRVVWOHZ3X3JZZXMII"
  },
  TENN: {
    marketCounter: 10,
    marketAppId: 76682426,
    marketAddress: "YPBU624YSQ5GXHV3XCPZAL7RA2MMSFEBYBB7Q2GU5ACENIL3R4CWFEU424"
  },
  ELVN: {
    marketCounter: 11,
    marketAppId: 76682444,
    marketAddress: "MWBHFQ73EBZ4TEJLCSYVHMFIGGXZW7B7BB4ZLEZ5SQFOJYD2ORA7EAK5GA"
  },
  TWLV: {
    marketCounter: 12,
    marketAppId: 76682494,
    marketAddress: "XTVSQ5QRADOMYQZDKI545VXOVLGKGAKK3U6ORPVHVCG5ADG4RXTSGVBBP4"
  },
  TRTN: {
    marketCounter: 13,
    marketAppId: 76682511,
    marketAddress: "5BQCKQUCFCZ37JPVM3I4QOREYFIAHKTOSMWXL3IQDRXTLS5EPGWVUPPKJQ"
  },
  FRTN: {
    marketCounter: 14,
    marketAppId: 76682529,
    marketAddress: "SYI2JEA42PVAR56X6HJKK4FLYR2BUBN64H5PY6WWAPZ5UX6YAFQPJ6JJLM"
  },
  FVTN: {
    marketCounter: 15,
    marketAppId: 76682539,
    marketAddress: "LGPVP5Z643ZHPJ2JHMCHGZQ3LMJVTDMQ3JIZ4T5D3JXBLZ6JCYPOHFDS6A"
  },
  SXTN: {
    marketCounter: 16,
    marketAppId: 76682558,
    marketAddress: "ISOIDKEXB43ZIDJFM3QUWTGLCGOQ5US2D5RIOOUKUBF3OSC5H3ZIV54NJA"
  }
}
export const foreignAppIds = [76682298, 76682307, 76682318, 76682330, 76682345, 76682360]

export const SECONDS_PER_YEAR = 60 * 60 * 24 * 365
export const SCALE_FACTOR = 1e9
export const REWARDS_SCALE_FACTOR = 1e14
export const PARAMETER_SCALE_FACTOR = 1e3

let orderedOracleAppIds = []
let orderedMarketAppIds = []
let orderedMarketData = []
let orderedSupportedMarketAppIds = []
let marketCounterToAssetName = {}
let assetIdToAssetName = {}
for (const assetName of orderedAssets) {
  orderedOracleAppIds.push(assetDictionary[assetName]["oracleAppId"])
  orderedSupportedMarketAppIds.push(assetDictionary[assetName]["marketAppId"])
  marketCounterToAssetName[assetDictionary[assetName]["marketCounter"]] = assetName
  assetIdToAssetName[assetDictionary[assetName]["underlyingAssetId"]] = assetName
  assetIdToAssetName[assetDictionary[assetName]["bankAssetId"]] = "b" + assetName
}
for (const assetName of extraAssets) {
  assetIdToAssetName[assetDictionary[assetName]["underlyingAssetId"]] = assetName
}

for (const assetName of orderedAssetsAndPlaceholders) {
  orderedMarketAppIds.push(assetDictionary[assetName]["marketAppId"])
}
export {
  orderedOracleAppIds,
  orderedMarketAppIds,
  orderedSupportedMarketAppIds,
  marketCounterToAssetName,
  assetIdToAssetName
}
